export const INDICATOR_CARD_WIDTH = 525;
export const SPACE_BETWEEN_INDICATORS = 16;
